var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "c-carousel" },
    [
      _c(
        "vue-glide",
        {
          attrs: { bullet: false, perView: 1, bound: true },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _vm._l(_vm.imageable, function (image) {
            return _c("vue-glide-slide", { key: image.image_id }, [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openModal()
                    },
                  },
                },
                [
                  image.image_id
                    ? _c("ResponsiveImage", {
                        attrs: { id: image.image_id, css: "c-carousel__image" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  image.image_id
                    ? _c("ImageCaption", {
                        attrs: {
                          id: image.image_id,
                          css: "c-carousel__caption",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
          _vm._v(" "),
          _c("template", { staticClass: "glide__nav", slot: "control" }, [
            _c(
              "button",
              {
                staticClass: "c-carousel__nav c-carousel__nav--prev",
                attrs: { "data-glide-dir": "<", "aria-label": "Forrige bilde" },
              },
              [_c("icon-left", { staticClass: "c-carousel__icon" })],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "c-carousel__nav c-carousel__nav--next",
                attrs: { "data-glide-dir": ">", "aria-label": "Neste bilde" },
              },
              [_c("icon-right", { staticClass: "c-carousel__icon" })],
              1
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "c-carousel__thumbnails" },
        _vm._l(_vm.imageable, function (image, index) {
          return _c(
            "button",
            {
              key: image.image_id,
              staticClass: "c-carousel__indicator",
              class: { "is-active": index === _vm.active },
              on: {
                click: function ($event) {
                  _vm.active = index
                },
              },
            },
            [
              image.image_id
                ? _c("ResponsiveImage", {
                    class: "c-carousel__thumbnail",
                    attrs: { id: image.image_id },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }